module.exports = __webpack_public_path__ + "img/MatchSoldier.758d2028.jpg";